import React from 'react';
import { ButtonComponent, FormGrid, SearchComponent } from 'components/common';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { push } from 'connected-react-router';
import { routes } from 'constants/common';
import { FilterTypes } from 'ducks/boUsers/types';
import { requestExportBoUsers, selectFilters, setFilter } from 'ducks/boUsers';
import AddIcon from '@material-ui/icons/Add';
import { selectAccessToPages } from 'ducks/auth';
import { Permissions } from 'ducks/groups/types';

export const SearchToolbar = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const filters = useSelector(selectFilters);

    const handleExportUsers = () => {
        dispatch(requestExportBoUsers());
    };
    const accessToPages = useSelector(selectAccessToPages);
    const allowedToCreate = accessToPages[Permissions.BO_USER_CREATE];
    const allowedToExport = accessToPages[Permissions.BO_USER_EXPORT];
    const redirectToUserCreation = () => dispatch(push(routes.NEW_BO_USER));

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length >= 2 || e.target.value.length === 0) {
            dispatch(
                setFilter({
                    filterType: FilterTypes.SearchText,
                    value: e.target.value,
                }),
            );
        }
    };

    return (
        <FormGrid columnAmount={2} padding="10px 0" rowHeight="20px">
            <SearchComponent
                placeholder={t('search')}
                onChange={handleSearch}
                defaultValue={filters[FilterTypes.SearchText]}
            />
            <FormGrid columnAmount={2} rowHeight="20px" padding="0">
                {allowedToCreate && (
                    <ButtonComponent
                        text={t('add')}
                        startIcon={<AddIcon />}
                        handleClick={redirectToUserCreation}
                    />
                )}
                {allowedToExport && (
                    <ButtonComponent
                        text={t('download')}
                        startIcon={<SaveAltIcon />}
                        handleClick={handleExportUsers}
                    />
                )}
            </FormGrid>
        </FormGrid>
    );
};
